import { Form } from 'react-bootstrap'

import { AvailableFields } from './lumber-dimensions-select-dropdow'
import Tooltip, { TooltipProps } from '../../../../../../../../shared/components/tooltip/tooltip'

interface DimensionalSelectFieldProps {
    fieldFor: AvailableFields
    tooltipData?: TooltipProps['tooltipData']
    onFieldChange: (value: string, fieldName: AvailableFields) => void
    placeholder: string
    options: {
        enumNames: string[]
        enum: string[]
    }
    value?: string | null
    disabled?: boolean
    required?: boolean
}

export const DimensionalSelectField = ({
    fieldFor,
    tooltipData = undefined,
    onFieldChange,
    value,
    placeholder,
    options,
    disabled = false,
    required = false,
}: DimensionalSelectFieldProps) => {
    return (
        <Tooltip tooltipData={tooltipData}>
            <div className={`dimension-field-wrapper ${fieldFor}`}>
                <Form.Select
                    className="dimension-field"
                    disabled={disabled}
                    onChange={(e) => onFieldChange(e.target.value, fieldFor)}
                    required={required}
                    value={value ?? ''}
                >
                    <option value="">{placeholder}</option>
                    {options.enumNames?.map((option, index) => (
                        <option key={option} value={options.enum?.[index] as string}>
                            {option}
                        </option>
                    ))}
                </Form.Select>
            </div>
        </Tooltip>
    )
}
export default DimensionalSelectField
